import React from 'react'
import s from './LinkCloud.less'

const LinkCloud = ({ links }) => {
  return (
    <ul className={s.list}>
      {links.map(({ url, label }, index) => (
          <li key={index} className={s.item}>
            <a href={url} className={s.link}>
              {label}
            </a>
          </li>
        )
      )}
    </ul>
  )
}

export default LinkCloud
